// extracted by mini-css-extract-plugin
export default {"cities":"Cities_cities__m4Lfx","wrapper":"Cities_wrapper__SP02P","cities_list":"Cities_cities_list__F4FRC","menu_active":"Cities_menu_active__nN3w8"};